import { Playground } from 'docz';
import { useToggle } from "../../../../../src/index";
import * as React from 'react';
export default {
  Playground,
  useToggle,
  React
};